import React from "react";
import SimpleTooltip from "./SimpleTooltip";
import { FiCopy } from "react-icons/fi";
import { CopyToClipboard } from "react-copy-to-clipboard";

class ClickToCopyButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isCopied: false,
    };
  }

  render() {
    const { isCopied } = this.state;
    const {
      copyText, // text to copy
      buttonText, // text on button
      tooltipMessage = "Click to copy",
      place,
    } = this.props;
    return (
      <>
        <div className="flex items-center">
          <SimpleTooltip
            place={place}
            tooltipText={isCopied ? "Copied!" : tooltipMessage}
          >
            <CopyToClipboard
              text={copyText}
              onCopy={() => this.setState({ isCopied: true })}
            >
              <button
                type="button"
                className="shadow rounded flex items-center bg-blue-200 px-4 py-2 font-semibold text-blue-900 hover:bg-blue-300"
                onMouseLeave={() => this.setState({ isCopied: false })}
              >
                <span className={buttonText ? "mr-2" : ""}>
                  <FiCopy></FiCopy>
                </span>
                {buttonText}
              </button>
            </CopyToClipboard>
          </SimpleTooltip>
        </div>
      </>
    );
  }
}

export default ClickToCopyButton;
